module.exports = __webpack_public_path__ + "img/feature-details-active.dda2847e.svg";